import InsuredToSave from '@/modules/common/common/models/MID/InsuredToSave'
import CommonMapper from '@/modules/core/mappers/CommonMapper'

import type LifeHiringInsured from '@/modules/life/hiring/models/APP/LifeHiringInsured'
import LifeSaveInsuredsRequest from '@/modules/life/hiring/models/MID/requests/LifeSaveInsuredsRequest'

export default class SaveInsuredMapper {
  static toRequest(quotationId: string, insureds: LifeHiringInsured[]): LifeSaveInsuredsRequest {
    const insuredToSave = insureds.map(
      (insured) =>
        new InsuredToSave({
          riskNumber: insured.riskNumber,
          nacionality: insured.addressDetails.country,
          documentType: insured.documentDetails.documentType,
          documentNumber: insured.documentDetails.documentNumber,
          documentExpirationDate: insured.documentDetails.documentExpirationDate
            ? CommonMapper.toMiddlewareDate(insured.documentDetails.documentExpirationDate)
            : undefined,
          name: insured.userDetails.name?.toUpperCase(),
          firstSurname: insured.userDetails.surname1?.toUpperCase(),
          secondSurname: insured.userDetails.surname2?.toUpperCase(),
          birthDate: CommonMapper.toMiddlewareDate(insured.userDetails.birthDate),
          sex: insured.userDetails.gender,
          streetType: insured.addressDetails.streetType,
          street: insured.addressDetails.address,
          city: insured.addressDetails.city,
          house: insured.addressDetails.roadNumber,
          postalCode: insured.addressDetails.postalCode,
          province: insured.addressDetails.province,
          houseType: insured.addressDetails.houseType,
          gateway: insured.addressDetails.gateway,
          stair: insured.addressDetails.stair,
          floor: insured.addressDetails.floor,
          doorway: insured.addressDetails.doorway,
          restAddres: insured.addressDetails.addressExtra,
          addressNormalice: insured.addressDetails.addressNormalize,
          email: insured.userDetails.email,
          prefix: insured.userDetails.prefix,
          mobilePhone: insured.userDetails.phone,
          policyHolderConsent: true
        })
    )

    return new LifeSaveInsuredsRequest({
      quotationId,
      insureds: insuredToSave
    })
  }
}
